<template>
  <div>
    <AppHeader @handleLoginBack="init" />
    <div class="container">
      <div class="control-bar" v-if="this.$store.state.token">
        <div class="logout" @click="handleLogout">{{ $t('logout') }}</div>
        <div class="edit" @click="handleRoute('/babe/edit')">
          {{ $t('edit') }}
        </div>
      </div>
      <div class="info-box">
        <div
          class="avatar"
          :style="{
            backgroundImage: 'url(' + $store.state.imgUrl + info.avatar + ')'
          }"></div>
        <div class="name">{{ info.name }}</div>
        <div class="contact">{{ info.email }}</div>
        <div class="mcn up">{{ info.mcn_name }}</div>
        <div class="des">
          <span v-if="!showMore">{{
            info.profile && info.profile.length > 100
              ? info.profile.slice(0, 100) + '...'
              : info.profile
          }}</span>
          <span v-else>{{ info.profile }}</span>
          <span
            class="show-more"
            @click="handleMore"
            v-if="
              info.profile && info.profile.length > 100 && !showMore
            "></span>
          <span
            class="show-more up"
            @click="handleMore"
            v-if="info.profile && info.profile.length > 100 && showMore"></span>
        </div>
      </div>
      <div class="icon-block">
        <div class="icon photo" v-if="info.ins">
          <a :href="info.ins" target="_blank"></a>
        </div>
        <div class="icon facebook" v-if="info.facebook">
          <a :href="info.facebook" target="_blank"></a>
        </div>
        <div class="icon twitter" v-if="info.twitter">
          <a :href="info.twitter" target="_blank"></a>
        </div>
      </div>
      <div class="list-title2">{{ $t('mynfts') }}</div>
      <div class="list2" v-if="nftList && nftList.length > 0">
        <div
          class="item"
          v-for="(item, index) in nftList"
          :key="index"
          @click="handleRoute('/babe/hotnft', item)">
          <div
            class="img-box"
            :style="{
              backgroundImage: 'url(' + $store.state.imgUrl + item.image + ')'
            }"></div>
          <div class="num icon">{{ item.price }}</div>
          <div class="price up">
            {{ item.sold }} <span class="unit special">{{ $t('sold') }}</span>
          </div>
        </div>
      </div>
      <template v-if="nftList && nftList.length <= 0">
        <EmptyBox :text="$t('nonft')" type="nft" />
        <el-button
          class="el-button--special2 block"
          @click="handleRoute('/babe/mint')"
          >{{ $t('add.text75') }}</el-button
        >
        <div class="open-area" style="height: 0.8rem"></div>
      </template>
    </div>
  </div>
</template>
<script>
import {
  postBabeInviteConfirm,
  postBabeNftMynft,
  postBabeUserLogout,
  postUserInfoBabe
} from '@/api/babe'
import EmptyBox from '@/components/EmptyBox.vue'

export default {
  name: 'BabeAccount',
  components: { EmptyBox },
  data() {
    return {
      nftList: null,
      info: {
        avatar: '',
        name: '',
        email: '',
        mcn_name: '',
        profile: ''
      },
      showMore: false
    }
  },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  created() {
    if (this.$route.query && this.$route.query.inviteToken) {
      let params = {
        token: this.$route.query.inviteToken
      }
      postBabeInviteConfirm(params).then((res) => {
        this.$toast({
          message: this.$t('loginpage.text2'),
          iconClass: 'icon icon-success'
        })
        this.$store.dispatch('Login', res.data)
        this.$store.dispatch('setInvite', null)
        this.$router.push('/')
        this.init()
      })
    } else {
      this.init()
    }
  },
  methods: {
    init() {
      console.log(888)
      postUserInfoBabe().then((res) => {
        this.$store.dispatch('UserInfo', res.data)
        this.info = res.data
      })
      postBabeNftMynft().then((res) => {
        this.nftList = res.data
      })
    },
    handleRoute(path, item) {
      if (item) {
        this.$router.push({ path: path, query: { rec_code: item.rec_code } })
      } else {
        this.$router.push({ path: path })
      }
    },
    handleLogout() {
      let that = this
      postBabeUserLogout().then((res) => {
        that.$toast({
          message: this.$t('accountpage.text19')
        })
        that.$store.dispatch('LogOut')
        that.$router.push('/')
      })
    },
    handleMore() {
      this.showMore = !this.showMore
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/babe/account.vue